import { Modal } from "antd";
import React from "react";
import { OemForm } from "../../../modules/Oem/Components/OemForm";
import { DealerForm } from "../../../modules/Dealer/Components/DealerForm";
import { CustomerForm } from "../../../modules/Customer/Components/CustomerForm";
import { LicenseForm } from "../../../modules/License/Components/LicenseForm";
import { ProductionForm } from "../../../modules/Production/Components/ProductionForm";
import { AccountForm } from "../../../modules/Account/Components/AccountForm";
const AccountCreationModal = ({
  modalType,
  isOpenModal,
  setIsOpenModal,
  setDefaultData,
  defaultData,
  setModalType,
  isModal,
  title,
  refetch,
  setAccountId,
  disbaleDealerField,
  disableCustomerField,
}) => {
  console.log(defaultData, modalType);

  return isModal ? (
    <div className="container-fluid mx-auto ">
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
        title={title}
        destroyOnClose
      >
        {modalType === "OEM" ? (
          <OemForm
            // type={"edit"}
            isModalForm={isOpenModal}
            setDefaultData={setDefaultData}
            onCancel={() => {
              setIsOpenModal(false);
              setModalType(null);
            }}
            defaultData={defaultData}
            createNew
          />
        ) : modalType === "Dealer" ? (
          <DealerForm
            type={"edit"}
            isModalForm={isOpenModal}
            setDefaultData={setDefaultData}
            onCancel={() => {
              setIsOpenModal(false);
              setModalType(null);
            }}
            defaultData={defaultData}
          />
        ) : modalType === "Customer" ? (
          <CustomerForm
            type={"edit"}
            isModalForm={isOpenModal}
            setDefaultData={setDefaultData}
            onCancel={() => {
              setIsOpenModal(false);
              setModalType(null);
            }}
            defaultData={defaultData}
          />
        ) : modalType === "Production" ? (
          <ProductionForm
            type={"edit"}
            isModalForm={isOpenModal}
            setDefaultData={setDefaultData}
            onCancel={() => {
              setIsOpenModal(false);
              setModalType(null);
            }}
            defaultData={defaultData}
          />
        ) : modalType === "License" ? (
          <LicenseForm
            type={"edit"}
            isModalForm={isOpenModal}
            onCancel={() => {
              setIsOpenModal(false);
              // setModalType(null);
            }}
            setDefaultData={setDefaultData}
          />
        ) : modalType === "AccountCreate" ? (
          <AccountForm
            // type={"edit"}
            isModalForm={isOpenModal}
            onCancel={() => {
              setIsOpenModal(false);
              refetch && refetch();
              // setModalType(null);
            }}
            defaultData={defaultData}
            disbaleDealerField={disbaleDealerField}
            disableCustomerField={disableCustomerField}
          />
        ) : modalType === "AccountEdit" ? (
          <AccountForm
            type={"edit"}
            isModalForm={defaultData?.AccountNo}
            onCancel={() => {
              setIsOpenModal(false);
              refetch && refetch();
              setAccountId(null);
              // setModalType(null);
            }}
            defaultData={defaultData}
          />
        ) : null}
      </Modal>
    </div>
  ) : (
    <div className="container-fluid mx-auto ">
      {/* <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
      > */}
      {modalType === "OEM" ? (
        <OemForm
          type={"edit"}
          isModalForm={isOpenModal}
          setDefaultData={setDefaultData}
          onCancel={() => {
            setIsOpenModal(false);
            setModalType(null);
          }}
        />
      ) : modalType === "Dealer" ? (
        <DealerForm
          type={"edit"}
          isModalForm={isOpenModal}
          setDefaultData={setDefaultData}
          onCancel={() => {
            setIsOpenModal(false);
            setModalType(null);
          }}
          defaultData={defaultData}
        />
      ) : modalType === "Customer" ? (
        <CustomerForm
          type={"edit"}
          isModalForm={isOpenModal}
          setDefaultData={setDefaultData}
          onCancel={() => {
            setIsOpenModal(false);
            setModalType(null);
          }}
          defaultData={defaultData}
        />
      ) : modalType === "Production" ? (
        <ProductionForm
          type={"edit"}
          isModalForm={isOpenModal}
          setDefaultData={setDefaultData}
          onCancel={() => {
            setIsOpenModal(false);
            setModalType(null);
          }}
          defaultData={defaultData}
        />
      ) : modalType === "License" ? (
        <LicenseForm
          type={"edit"}
          isModalForm={isOpenModal}
          onCancel={() => {
            setIsOpenModal(false);
            // setModalType(null);
          }}
          setDefaultData={setDefaultData}
        />
      ) : null}
      {/* </Modal> */}
    </div>
  );
};

export default AccountCreationModal;
